import { push } from 'react-router-redux';

import { addToQuery, removeFromQuery } from 'dpl/util/queryString';

export function pushParams(params = {}) {
  return push({
    pathname: window.location.pathname,
    search: addToQuery(params)
  });
}

export function replaceParams(params = {}) {
  return push({
    pathname: window.location.pathname,
    search: addToQuery(params, '')
  });
}

export function resetParams(...paramNames) {
  return push({
    pathname: window.location.pathname,
    search: removeFromQuery(paramNames)
  });
}
